"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const HelperText_1 = require("./HelperText");
const TextFieldValidator = (_a) => {
    var _b, _c, _d, _e, _f, _g, _h;
    var { t, validationSchema, isTouched, onBlur, value } = _a, rest = __rest(_a, ["t", "validationSchema", "isTouched", "onBlur", "value"]);
    const classes = useStyles();
    const [touched, setTouched] = React.useState(isTouched);
    const hasError = () => {
        if (!touched) {
            return false;
        }
        return validationSchema ? !validationSchema.isValidSync(value) : false;
    };
    const onTouch = (event) => {
        if (onBlur) {
            onBlur(event);
        }
        setTouched(true);
    };
    const isError = hasError() || !!rest.error;
    const errorText = (_b = rest.helperText) !== null && _b !== void 0 ? _b : t('field.error', 'Please enter a valid ' + ((_c = rest.label) !== null && _c !== void 0 ? _c : (_d = rest.inputProps) === null || _d === void 0 ? void 0 : _d['aria-label']), {
        fieldLabel: (_e = rest.label) !== null && _e !== void 0 ? _e : (_f = rest.inputProps) === null || _f === void 0 ? void 0 : _f['aria-label']
    });
    const helperText = isError ? errorText : (_g = rest.helperText) !== null && _g !== void 0 ? _g : '';
    const [errorKey, setErrorKey] = React.useState(0);
    const handleBlur = (e) => {
        onTouch(e);
        if (!e.target.validity.valid) {
            setErrorKey(prevKey => prevKey + 1);
        }
    };
    return ((0, jsx_runtime_1.jsx)(core_1.TextField, Object.assign({ value: value }, rest, { inputProps: Object.assign(Object.assign({}, rest.inputProps), { 'aria-label': (_h = rest.inputProps) === null || _h === void 0 ? void 0 : _h['aria-label'] }), onBlur: handleBlur, error: isError, FormHelperTextProps: { className: classes.helperText }, helperText: (0, jsx_runtime_1.jsx)(HelperText_1.default, { helperText: helperText, isError: isError }, errorKey) }, (rest.hiddenLabel ? { label: '' } : {}))));
};
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    helperText: {
        display: 'flex',
        gap: theme.spacing(1),
        marginLeft: 0,
        marginRight: 0,
        marginTop: theme.spacing(0.5),
        alignItems: 'center'
    }
}));
exports.default = (0, react_i18next_1.withTranslation)()(TextFieldValidator);
//# sourceMappingURL=TextFieldValidator.js.map